import { css } from '@sitebase/emotion';
import { colorMonochromeWhite, colorPrimary500, colorPrimary100, lineHeight } from '../settings';

export var itemUnderline = /*#__PURE__*/css('/*! itemUnderline */');
export var itemActive = /*#__PURE__*/css('/*! itemActive */');
export var item = /*#__PURE__*/css('align-items:center;color:', colorPrimary100, ';display:flex;flex:1 0 auto;height:100%;line-height:', lineHeight, ';margin:0 8px;white-space:nowrap;flex-direction:column;justify-content:center;');
export var itemCursorPointer = /*#__PURE__*/css('cursor:pointer;');

var _ref = '&:hover,&:active{color:';
var _ref2 = ';}&.';
var _ref3 = '{color:';
var _ref4 = ';position:relative;&.';
var _ref5 = '{&::after{content:\'\';height:0;width:100%;margin-bottom:-1px;border-bottom:1px solid ';
var _ref6 = ';}}}';
export var itemThemed = function itemThemed(theme) {
  var color = theme === 'light' ? colorPrimary500 : colorMonochromeWhite;
  return (/*#__PURE__*/css(_ref, color, _ref2, itemActive, _ref3, color, _ref4, itemUnderline, _ref5, color, _ref6)
  );
};